"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SzSideMenu = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_transition_group_1 = require("react-transition-group");
require("./SzSideMenu.scss");
function SzSideMenu(_a) {
    var children = _a.children, className = _a.className, isOpen = _a.isOpen;
    var menuClasses = classnames_1.default('sz-aside overflow-hidden bg-white text-secondary', className, {
        open: isOpen
    });
    return (react_1.default.createElement(react_transition_group_1.CSSTransition, { in: isOpen, timeout: 0, classNames: "sz-aside" },
        react_1.default.createElement("aside", { className: menuClasses },
            react_1.default.createElement("nav", null,
                react_1.default.createElement("ul", { className: "sz-aside__list list-unstyled m-0" }, children)))));
}
exports.SzSideMenu = SzSideMenu;
var Item = function (_a) {
    var children = _a.children, active = _a.active, onClick = _a.onClick;
    var itemClasses = classnames_1.default('sz-aside__item d-flex align-items-center cursor-pointer', {
        active: active
    });
    return (react_1.default.createElement("li", { className: itemClasses, onClick: onClick }, children));
};
SzSideMenu.Item = Item;
SzSideMenu.defaultProps = {
    isOpen: true
};
exports.default = SzSideMenu;
